import { isDemo } from '../GlobalContex';
import EditorPlaceholder from '../components/builder/EditorPlaceholder/EditorPlaceholder';
import Preview from '../components/builder/Preview/Preview';
import useMediaQuery from '../hooks/useMediaQuery';

export default function BuilderRoute() {
  const isMobile = useMediaQuery({ max: 991 });
  return isMobile && isDemo ? null :
         isMobile ? <Preview /> : <EditorPlaceholder />;
}
